import { dayNoteApi } from '@/store/api/calendar/calendar.daynote.api';
import type { TypeAppDispatch } from '@/store/store';
import type { TypeDayNote } from '@/types/calendar/types.calendar';

export const writeDayNote = (dispatch: TypeAppDispatch, note: TypeDayNote): void => {
    dispatch(dayNoteApi.util.upsertQueryData('readDayNote', note.date, note));
};
